import * as token from "@universityofmaryland/web-token-library";
import "./blocks.js";
import { createCompositeCarouselFullScreen } from "./full-screen.js";
import { createCompositeCarouselImage } from "./image.js";
import { layoutImage } from "../../../layout/image.js";
import "@universityofmaryland/web-builder-library";
import "@universityofmaryland/web-styles-library";
const ELEMENT_CAROUSEL_OVERLAY_COINTAINER = "carousel-overlay-container";
const OverlayImageContainerStyles = `
  .${ELEMENT_CAROUSEL_OVERLAY_COINTAINER} {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${token.color.gray.dark};
  }

  .${ELEMENT_CAROUSEL_OVERLAY_COINTAINER} img {
    object-fit: contain;
    max-height: 100%;
  }
`;
const STYLES_CAROUSEL_OVERLAY_ELEMENT = `
  ${layoutImage.Styles}
  ${OverlayImageContainerStyles}
`;
const CreateOverlaySlide = ({ images }) => images.map((image) => {
  const slide = document.createElement("div");
  const imageContainer = document.createElement("div");
  const imageBlock = layoutImage.CreateElement({
    image,
    showCaption: true
  });
  imageContainer.classList.add(ELEMENT_CAROUSEL_OVERLAY_COINTAINER);
  imageContainer.appendChild(imageBlock);
  slide.appendChild(imageContainer);
  return slide;
});
const createCompositeCarouselOverlay = ({ images }) => (() => {
  let styles = STYLES_CAROUSEL_OVERLAY_ELEMENT;
  const setFullScreen = (index) => {
    let canMove = true;
    const checkKeyEvents = (event) => {
      if (!canMove) return;
      canMove = false;
      if (event.key == "ArrowLeft") overlayCarousel.events.EventSlideLeft();
      if (event.key == "ArrowRight") overlayCarousel.events.EventSlideRight();
      setTimeout(() => {
        canMove = true;
      }, 700);
    };
    overlayCarousel.events.EventMoveTo(index);
    setTimeout(() => fixedFullScreen.events.show(), 100);
    setTimeout(() => {
      overlayCarousel.events.EventResize();
    }, 100);
    isFullScreenEvents = window.addEventListener("keyup", checkKeyEvents);
  };
  const overlaySlides = CreateOverlaySlide({ images });
  const overlayCarousel = createCompositeCarouselImage({
    slides: overlaySlides,
    maxHeight: window.innerHeight / 10 * 8
  });
  styles += overlayCarousel.styles;
  const fixedFullScreen = createCompositeCarouselFullScreen({
    content: overlayCarousel.element,
    callback: () => {
      if (isFullScreenEvents)
        window.removeEventListener("keyup", isFullScreenEvents);
    }
  });
  styles += fixedFullScreen.styles;
  let isFullScreenEvents = null;
  return {
    element: fixedFullScreen.element,
    styles,
    events: {
      setFullScreen
    }
  };
})();
export {
  createCompositeCarouselOverlay
};
//# sourceMappingURL=overlay.js.map
